







import { Component, Vue, Prop, Watch, Model } from 'vue-property-decorator';

@Component({
  name: 'ui-checkbox',
})
export default class UiCheckBoxComponent extends Vue {
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: 'icon-check' }) icon: string;
  @Model('change', { default: false }) checked: boolean;

  // id = `chbox_${Math.floor(Math.random() * 1000) + 1}`;

  // name: string = "";
  private innerChecked: boolean = this.checked;
  //-------------------------------------------------------------

  onClick() {
    if (!this.disabled) this.innerChecked = !this.innerChecked;
    this.$emit('change', this.innerChecked);
  }

  @Watch('checked')
  onChanged() {
    this.innerChecked = this.checked;
    this.$emit('change', this.innerChecked);
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-components/~/ui-checkbox/src/ui-checkbox.vue